export default "__VITE_ASSET__DiFkWLy2__"